
import React from 'react';
import { SettingsIcon } from './icons';

interface HeaderProps {
  onOpenSettings: () => void;
  version: string;
}

const Header: React.FC<HeaderProps> = ({ onOpenSettings, version }) => {
  return (
    <header className="relative text-center p-4 border-b border-slate-200 dark:border-slate-700">
      <h1 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text" style={{ fontFamily: "'Poppins', sans-serif", backgroundImage: 'linear-gradient(to right, var(--primary-400), var(--primary-500))' }}>
        The Power-Up Pact
      </h1>
      <p className="mt-1 text-base text-slate-500 dark:text-slate-400">Our Guide to a Great Balance | Version {version}</p>
      <button 
        onClick={onOpenSettings} 
        className="absolute top-1/2 -translate-y-1/2 right-4 p-2 text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white transition-colors rounded-full hover:bg-slate-200 dark:hover:bg-slate-700"
        aria-label="Open Settings"
      >
        <SettingsIcon className="w-6 h-6" />
      </button>
    </header>
  );
};

export default Header;
